/**
 * Main Parameter Management Page — clean tabbed layout
 */
import React, { useState } from 'react';
import {
  Box,
  Typography,
  Tabs,
  Tab,
} from '@mui/material';

import GlobalParameters from './GlobalParameters';
import StoreParameters from './StoreParameters';
import ProductParameters from './ProductParameters';
import AdvancedParameters from './AdvancedParameters';
import TemplateManagement from './TemplateManagement';
import ChangeHistory from './ChangeHistory';
import TabPanel from '../Common/TabPanel';

const ParametersPage: React.FC = () => {
  const [currentTab, setCurrentTab] = useState(0);

  const handleTabChange = (_event: React.SyntheticEvent, newValue: number) => {
    setCurrentTab(newValue);
  };

  return (
    <Box>
      {/* Page title */}
      <Box sx={{ mb: '20px' }}>
        <Typography sx={{ fontSize: 'var(--text-xl)', fontWeight: 600, color: 'var(--color-text-primary)', fontFamily: 'var(--font-heading)' }}>
          Parameter Management
        </Typography>
        <Typography sx={{ fontSize: 'var(--text-base)', color: 'var(--color-text-muted)', mt: 0.5, fontFamily: 'var(--font-body)' }}>
          Configure system parameters for replenishment, forecasting, and inventory management
        </Typography>
      </Box>

      {/* Tab navigation */}
      <Box sx={{ borderBottom: '1px solid var(--color-border)', mb: 3 }}>
        <Tabs
          value={currentTab}
          onChange={handleTabChange}
          variant="scrollable"
          scrollButtons="auto"
        >
          <Tab label="Global Parameters" />
          <Tab label="Store Parameters" />
          <Tab label="Product Parameters" />
          <Tab label="Advanced" />
          <Tab label="Templates" />
          <Tab label="Change History" />
        </Tabs>
      </Box>

      {/* Tab content */}
      <Box className="page-enter">
        <TabPanel value={currentTab} index={0}>
          <GlobalParameters />
        </TabPanel>
        <TabPanel value={currentTab} index={1}>
          <StoreParameters />
        </TabPanel>
        <TabPanel value={currentTab} index={2}>
          <ProductParameters />
        </TabPanel>
        <TabPanel value={currentTab} index={3}>
          <AdvancedParameters />
        </TabPanel>
        <TabPanel value={currentTab} index={4}>
          <TemplateManagement />
        </TabPanel>
        <TabPanel value={currentTab} index={5}>
          <ChangeHistory />
        </TabPanel>
      </Box>
    </Box>
  );
};

export default ParametersPage;
